import { useState } from "react";

import KonamiCode from "@/components/KonamiCode";

import DraggableDialog from "../../../common-ui/draggable-dialog";
import FeatureOverrideContainer from "./FeatureOverrideContainer";

const konamiSequencePostfix = Object.freeze(["f", "o"] as const);

function FeatureOverride() {
    const [opened, setOpened] = useState(false);
    return (
        <>
            <KonamiCode callback={() => setOpened(true)} sequencePostfix={konamiSequencePostfix} />
            <DraggableDialog title="Feature Override" opened={opened} onClose={() => setOpened(false)}>
                <FeatureOverrideContainer />
            </DraggableDialog>
        </>
    );
}

export default FeatureOverride;
